const Uppy = require('@uppy/core');
const DragDrop = require('@uppy/drag-drop');
const ProgressBar = require('@uppy/progress-bar');

const contactForm = document.getElementById('contactForm');

const $ = window.jQuery || window.$;
let selectedFile = null;

const uppyOne = new Uppy({
  debug: true,
  autoProceed: true,
  restrictions: {
    maxNumberOfFiles: 1,
  },
  onBeforeUpload: (files) => checkUpload(files)
})
uppyOne
  .use(DragDrop, { target: '.uppy-files' })
  .use(ProgressBar, { target: '.uppy-progress-bar', hideAfterFinish: true })

uppyOne.on('file-added', (file) => {
  selectedFile = file.data

  const li = document.createElement('li')
  const a = document.createElement('a')

  a.href = '#'
  a.appendChild(document.createTextNode(file.name))

  li.appendChild(a)

  const list = document.querySelector('.uploaded-files ol')
  list.innerHTML = ''
  list.appendChild(li)

  document.querySelector('.js-error-message[data-field="cv"]').classList.add('hidden')
})

function checkUpload(files) {
  var uploaderError = document.querySelectorAll('.uploader')
  for (let i = 0; i < uploaderError.length; i++) {
    uploaderError[i].remove()
  }

  const maxFileSize = 5242880
  const extensions = ['pdf', 'doc', 'docx']

  var error = document.querySelector('.js-error-message[data-field=\'cv\']')

  for (key in files) {
    if (maxFileSize < files[key].size) {
      error.innerHTML = 'Max. file size: 5 MB'
      error.classList.remove('hidden')

      return Promise.reject()
    }
  }

  for (key in files) {
    if (extensions.indexOf(files[key].extension) === -1) {
      error.innerHTML = 'The cv must be a file of type: .pdf, .doc or .docx'
      error.classList.remove('hidden')

      return Promise.reject()
    }
  }
}

contactForm.addEventListener('submit', function (e) {
  e.preventDefault()
  const submitButton = window.FormSubmitState?.disable(contactForm)
  var errorMsg = document.querySelectorAll('.js-error-message')
  var fields = document.querySelectorAll('.js-field')

  for (let i = 0; i < errorMsg.length; i++) {
    errorMsg[i].classList.add('hidden')
  }

  for (let i = 0; i < fields.length; i++) {
    fields[i].classList.remove('border-red-500')
    fields[i].classList.add('border-dove-gray')
  }

  const formData = new FormData(contactForm)

  // attach file
  if (selectedFile) {
    formData.append('cv', selectedFile)
  }

  // axios.post(contactForm.action, new FormData(contactForm))
  axios.post(contactForm.action, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response) => {
      document.querySelector('.js-success-modal').classList.remove('hidden')
    })
    .catch((error) => {
      var errors = error.response?.data?.errors

      if (!errors) {
        window.FormSubmitState?.enable(contactForm, submitButton)
        return
      }

      for (const [key, value] of Object.entries(errors)) {
        var err = document.querySelector(".js-error-message[data-field='" + key + "']")
        var input = document.querySelector("[name='" + key + "']")

        if (!err && key === 'turnstile') {
          err = document.querySelector(".js-error-message[data-field='cf-turnstile-response']")
        }

        if (!err) {
          continue
        }

        if (key !== 'policy') {
          err.innerHTML = value
        }

        err.classList.remove('hidden')

        if (input) {
          input.classList.add('border-red-500')
          input.classList.remove('border-dove-gray')
        }
      }

      if (window.turnstile) {
        window.turnstile.reset()
      }

      window.FormSubmitState?.enable(contactForm, submitButton)
    })
})

$('.js-modal-close').on('click', function () {
  window.location.reload()
})
